import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import { ThemeProvider } from "@mui/material/styles";
import { BaseTheme } from "./themes/BaseTheme";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Layout from "./UI/Layout";
import MobileAppGate from "./components/MobileAppGate";
import UserContextProvider from "./contexts/UserContextProvider";
import DjContextProvider from "./contexts/DjContextProvider";
import { StripeProvider } from "./contexts/StripeContext";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d66ff4be5f5d20f05c7014e0753342cc@o4509739350687744.ingest.de.sentry.io/4509759541084240",
  sendDefaultPii: true,
});

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={"An error has occurred"}>
      <CssBaseline />
      <ThemeProvider theme={BaseTheme}>
        <UserContextProvider>
          <DjContextProvider>
            <StripeProvider>
              <BrowserRouter>
                <Provider store={store}>
                  <MobileAppGate>
                    <Layout>
                      <App />
                    </Layout>
                  </MobileAppGate>
                </Provider>
              </BrowserRouter>
            </StripeProvider>
          </DjContextProvider>
        </UserContextProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,

  document.getElementById("root")
);
